export default {
    setMessages(state, messages) {
        state.messages = messages;
    },
    messageExpired(state, message) {
        state.messages = state.messages.filter(m => message !== m);
    }
};
